(() => {
  if (window.pfhEmptySearchInitialised) return;
  window.pfhEmptySearchInitialised = true;
  const requests = new Map();
  let active;

  function close() {
    if (!active) return;
    active.panel.hidden = true;
    if (active.input.getAttribute('aria-controls') === active.panel.id) active.input.removeAttribute('aria-controls');
    active = null;
  }

  function resize() {
    if (!active) return;
    const viewport = window.visualViewport;
    const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
    active.panel.style.setProperty('--pfh-search-space', `${Math.max(0, bottom - active.panel.getBoundingClientRect().top - 12)}px`);
  }

  function load(panel) {
    const target = panel.querySelector('[data-pfh-best-sellers]');
    if (target.dataset.loaded) return;
    const url = panel.dataset.productsUrl;
    target.setAttribute('aria-busy', 'true');
    if (!requests.has(url)) {
      const request = fetch(url, { method: 'GET', credentials: 'same-origin' })
        .then(response => {
          if (!response.ok) throw new Error('Search suggestions unavailable');
          return response.text();
        })
        .then(html => {
          const result = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pfh-best-sellers-response]');
          if (!result) throw new Error('Search suggestions missing');
          return result.innerHTML;
        })
        .catch(error => { requests.delete(url); throw error; });
      requests.set(url, request);
    }
    requests.get(url).then(html => {
      target.innerHTML = html;
      target.dataset.loaded = 'true';
    }).catch(() => {
      // Popular searches remain usable. Retry products on the next focus.
    }).finally(() => target.setAttribute('aria-busy', 'false'));
  }

  document.querySelectorAll('.pfh-search-empty--inline').forEach(load);

  function open(input) {
    const root = input.closest('[data-pfh-empty-search]');
    if (!root || !input.matches('.search-input') || input.value.length) return;
    const panel = root.querySelector('.pfh-search-empty');
    document.dispatchEvent(new CustomEvent('pfh:hide-legacy-search'));
    if (active && active.panel !== panel) close();
    active = { root, input, panel };
    panel.hidden = false;
    input.setAttribute('aria-controls', panel.id);
    resize();
    load(panel);
  }

  document.addEventListener('focusin', event => {
    if (event.target.closest('.main-nav')) { close(); return; }
    if (active && !active.root.contains(event.target)) close();
    open(event.target);
  });
  document.addEventListener('click', event => open(event.target));
  document.addEventListener('mouseover', event => {
    if (event.target.closest('.main-nav')) close();
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-pfh-empty-search] .search-input')) {
      close();
      open(event.target);
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && active) {
      const input = active.input;
      close();
      if (document.activeElement !== input) { input.focus(); close(); }
    }
  });
  document.addEventListener('pointerdown', event => {
    if (active && !active.root.contains(event.target)) close();
  });
  document.addEventListener('focusout', () => {
    setTimeout(() => { if (active && !active.root.contains(document.activeElement)) close(); }, 0);
  });
  document.addEventListener('submit', event => {
    if (active && active.root.contains(event.target)) close();
  });
  document.addEventListener('shopify:section:unload', close);
  window.addEventListener('resize', resize);
  window.visualViewport?.addEventListener('resize', resize);
  window.visualViewport?.addEventListener('scroll', resize);
})();
